// extracted by css-extract-rspack-plugin
export default {"PercentageLabel":"x4grV","TooltipParagraph":"alsrP","TooltipContent":"KankW"};